import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Close } from "@mui/icons-material";
import { Entrada, Salida } from "assets/icons";
import { RequestServiceGet } from "services/services-mia/RequestServiceGet";
import { SEMAFORO_COLORS, ESTADO_LABELS } from "pages/migra/utils/usuarioPaso";

const TIPO_ICONS = { E: Entrada, S: Salida };

const BACKGROUND_POR_SEMAFORO = {
    V: "#15803d",
    A: "#b45309",
    R: "#b91c1c",
};

const BORDER_POR_SEMAFORO = {
    V: "#16a34a",
    A: "#d97706",
    R: "#dc2626",
};

// TODO ISO 27001: mismo criterio de tenant que Sign/index.jsx y DetalleModal.jsx;
// extraer a un helper compartido si aparece una tercera copia.
function getTenantName() {
    const origin = window.location.origin;
    if (origin === "https://clientes.miaid.me") return "evan-prod";
    if (origin === "https://clientes-dev.miaid.me") return "evan-dev";
    if (origin === "https://clientes-test.miaid.me") return "evan-test";
    return "evan-dev";
}

export default function MonitorPasoToast({ t, detalle, credentials }) {
    const [imagenURL, setImagenURL] = useState(null);

    const {
        usuarioApellidos,
        usuarioNombres,
        usuarioNroDeDocumentoX,
        tipoDeDocumentoCod,
        migraPasoNombre,
        migraUsuarioPasoTipo,
        migraUsuarioPasoFechaCheckin,
        migraUsuarioPasoSemaforo,
        migraUsuarioPasoEstado,
        migraUsuarioPasoAutenticacionId,
    } = detalle;

    useEffect(() => {
        if (!migraUsuarioPasoAutenticacionId) return;
        let active = true;

        RequestServiceGet(
            {
                service: "SBMAutenticacionGet",
                params: {
                    tenantNombre: getTenantName(),
                    autenticacionId: migraUsuarioPasoAutenticacionId,
                },
            },
            credentials
        ).then((result) => {
            if (active) setImagenURL(result?.[0]?.autenticacionImagenURL ?? null);
        });

        return () => { active = false; };
    }, [migraUsuarioPasoAutenticacionId, credentials]);

    const nombreCompleto = [usuarioApellidos, usuarioNombres].filter(Boolean).join(", ");
    const documento = [tipoDeDocumentoCod, usuarioNroDeDocumentoX].filter(Boolean).join(" ");
    const hora = migraUsuarioPasoFechaCheckin?.slice(11, 16) ?? "";
    const semaforo = migraUsuarioPasoSemaforo ?? "A";
    const background = BACKGROUND_POR_SEMAFORO[semaforo] ?? "#374151";
    const border = BORDER_POR_SEMAFORO[semaforo] ?? "#4b5563";
    const dotColor = SEMAFORO_COLORS[semaforo] ?? "#9ca3af";
    const TipoIcon = TIPO_ICONS[migraUsuarioPasoTipo];

    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            background,
            borderRadius: "16px",
            padding: "24px",
            boxShadow: "0 9px 26px rgba(0,0,0,0.22)",
            border: `2px solid ${border}`,
            borderLeft: "none",
            width: "580px",
            gap: "18px",
            position: "relative",
            overflow: "hidden",
        }}>
            <div style={{
                position: "absolute",
                left: 0, top: 0, bottom: 0,
                width: "9px",
                backgroundColor: dotColor,
            }} />

            {imagenURL && (
                <img
                    src={imagenURL}
                    alt="imagen de autenticación"
                    style={{
                        width: 140,
                        height: 140,
                        objectFit: "cover",
                        borderRadius: 14,
                        marginLeft: "4px",
                        flexShrink: 0,
                    }}
                />
            )}

            <div style={{ display: "flex", flexDirection: "column", flex: 1, paddingLeft: imagenURL ? 0 : "9px" }}>
                <span style={{ fontSize: "22px", fontWeight: "600", color: "#fff" }}>
                    {nombreCompleto || "Sin nombre"}
                </span>
                {documento && (
                    <span style={{ fontSize: "17px", color: "#fff", marginTop: "3px" }}>
                        {documento}
                    </span>
                )}

                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", marginTop: "12px", gap: "10px" }}>
                    {hora && (
                        <span style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "17px", fontWeight: "600", color: "#fff" }}>
                            {TipoIcon && (
                                <img src={TipoIcon} alt={migraUsuarioPasoTipo} style={{ width: 18, height: 18 }} />
                            )}
                            {hora}
                        </span>
                    )}
                    {migraPasoNombre && (
                        <span style={{
                            fontSize: "15px",
                            fontWeight: "500",
                            color: "#fff",
                            backgroundColor: "rgba(255,255,255,0.18)",
                            padding: "5px 11px",
                            borderRadius: "18px",
                        }}>
                            📍 {migraPasoNombre}
                        </span>
                    )}
                    {migraUsuarioPasoEstado && (
                        <span style={{ fontSize: "15px", fontWeight: "500", color: "#fff" }}>
                            {ESTADO_LABELS[migraUsuarioPasoEstado] ?? migraUsuarioPasoEstado}
                        </span>
                    )}
                </div>
            </div>

            <button
                type="button"
                onClick={() => toast.dismiss(t)}
                style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "rgba(255,255,255,0.6)",
                    padding: "4px",
                    alignSelf: "flex-start",
                    fontSize: "20px",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.6)")}
            >
                <Close fontSize="inherit" />
            </button>
        </div>
    );
}
